const FEATURE_ROOT_QUERY_KEY = "feature"

export const geoServerQueryKeys = {
    feature: (featureId, filters = {}) => [FEATURE_ROOT_QUERY_KEY, featureId, filters],
    linearLocation: (featureId) => [FEATURE_ROOT_QUERY_KEY, "linear_location", featureId],
}